import React, { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';

import TextField from './TextField';


const PasswordField = React.forwardRef((props, ref) => {
  const { leading = null, ...restProps } = props;

  const [visible, setVisible] = useState(false);

  const toggle = () => {
    setVisible((current) => !current);
  };

  const trailing = (
    <button
      type="button"
      tabIndex={-1}
      aria-label="toggle password visibility"
      className="flex items-center text-ink-subtle outline-none hover:text-ink-muted"
      onClick={toggle}
    >
      {visible
        ? (
          <EyeOff />
        )
        : (
          <Eye />
        )}
    </button>
  );

  return (
    <TextField
      ref={ref}
      autoComplete="current-password"
      {...restProps}
      leading={leading}
      trailing={trailing}
      type={visible ? 'text' : 'password'}
    />
  );
});

PasswordField.displayName = 'PasswordField';
export default PasswordField;
